import { buttonsFromSerializedInAppMessage as pe } from "../in-app-message-factory.js";
import InAppMessage from "./in-app-message.js";
export default class ModalMessage extends InAppMessage {
  constructor(
    e,
    r,
    s,
    t,
    i,
    o,
    a,
    p,
    m,
    n,
    u,
    c,
    d,
    f,
    l,
    g,
    j,
    v,
    x,
    z,
    h,
    w,
    y,
    S,
    b,
    k,
    q,
  ) {
    super(
      e,
      r,
      void 0,
      s,
      t,
      i,
      o,
      a,
      (p = p || InAppMessage.DismissType.MANUAL),
      m,
      n,
      u,
      c,
      d,
      f,
      l,
      g,
      j,
      v,
      x,
      z,
      h,
      w,
      y,
      S,
      (b = b || InAppMessage.CropType.FIT_CENTER),
      void 0,
      k,
      q,
    ),
      (this.Te = InAppMessage.TextAlignment.CENTER);
  }
  ss() {
    return super.ss(ModalMessage.es);
  }
  static an(e) {
    return new ModalMessage(
      e[InAppMessage.hs.ea],
      e[InAppMessage.hs.ra],
      e[InAppMessage.hs.xs],
      e[InAppMessage.hs.sa],
      e[InAppMessage.hs.ta],
      e[InAppMessage.hs.URI],
      e[InAppMessage.hs.ia],
      e[InAppMessage.hs.oa],
      e[InAppMessage.hs.pa],
      e[InAppMessage.hs.ma],
      e[InAppMessage.hs.os],
      e[InAppMessage.hs.na],
      e[InAppMessage.hs.ua],
      e[InAppMessage.hs.ca],
      e[InAppMessage.hs.fa],
      e[InAppMessage.hs.da],
      e[InAppMessage.hs.la],
      e[InAppMessage.hs.ga],
      e[InAppMessage.hs.ja],
      e[InAppMessage.hs.xa],
      e[InAppMessage.hs.za],
      e[InAppMessage.hs.ha],
      e[InAppMessage.hs.va],
      pe(e[InAppMessage.hs.wa]),
      e[InAppMessage.hs.ya],
      e[InAppMessage.hs.ba],
      e[InAppMessage.hs.CSS],
    );
  }
}
ModalMessage.es = InAppMessage.qe.un;
